/** 国旗图标配置 */
export const configIcon = {
  china: 'emojione:flag-for-china',
  china_hk: 'emojione:flag-for-hong-kong-sar-china',
  vietnam: 'emojione:flag-for-vietnam',
  thailand: 'emojione:flag-for-thailand',
  laos: 'emojione:flag-for-laos',
  singapore: 'emojione:flag-for-singapore',
  malaysia: 'emojione:flag-for-malaysia',
  usa: 'emojione:flag-for-united-states',
}
